import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  description:
    "Knowing the performance of codecs under different conditions is of particular interest to both technology providers and their customers. The MUSHRA method is suitable to conduct such assessment where it is expected to get various levels of audio impairments. In this section, you are asked to conduct a small fragment of MUSHRA listening test. Use headphones to listen and evaluate six conditions according to your subjective opinion.",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Participant view" }, { name: "Revealed description" }, { name: "Expert listeners results" }],
        },
      ],
      extraContent: [],
      components: [
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                rowsSize: [6, 1],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "iframe",
                          options: {
                            src: `${config.IFRAMES_STATIC_URL}/0226/index.html?config=default_step2_nonames.yaml`,
                          },
                        },
                      },
                    },
                  ],
                  //second row
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "hint",
                          options: {
                            data:
                              "Additional information: as it is normal practice not to provide listeners with any background information or test context (to avoid potential bias), we are not giving any hints with regard to the configuration of this test. See the “Revealed description” page for details.",
                            direction: "row",
                          },
                        },
                        styles: {
                          width: "80%",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                rowsSize: [6, 1],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "iframe",
                          options: {
                            src: `${config.IFRAMES_STATIC_URL}/0226/index.html?config=default_step2_names.yaml`,
                          },
                        },
                      },
                    },
                  ],
                  //second row
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "hint",
                          options: {
                            data:
                              "Additional information: apart from the hidden reference and the 7 kHz low-pass filter anchor, the rest of conditions represents four systems where the same codec was used at four different bit rates. The relationship between used bit rates is as follows: System B bit rate = 2x System A bit rate, System C bit rate = 3x System A bit rate, System D bit rate = 6x System A bit rate.",
                            direction: "row",
                          },
                        },
                        styles: {
                          width: "80%",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                rowsSize: [6, 1],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "image",
                          options: {
                            src: `${config.ASSETS_URL}/02/26/principle/slide2-figure1.svg`,
                          },
                        },
                      },
                    },
                  ],
                  //second row
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "hint",
                          options: {
                            data:
                              "Additional information: in the graph above you can see the results - the mean and the 95% confidence interval - obtained from the results of eight expert listeners. What was your score?",
                            direction: "row",
                          },
                        },
                        styles: {
                          width: "80%",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
